export const paths = () => {
  return {
    USER: {
      LOGIN: '/login',
      ASK_PASSWORD: '/password',
      INFO: '/users/me',
      CHANGE_PASSWORD: '/users/change-password',
      CHANGE_INFO: '/users',
    },
    SYNC: {
      INITIAL_FRESH: '/mobile/sweet-water/summary',
      INITIAL_SEA: '/mobile/sea-water/summary',
    },
    STATES: {
      CHANGE_FRESH: '/mobile/sweet-water/send/states',
      CHANGE_SEA: '/mobile/sea-water/send/states',
      CHANGE_FILTER_UV: '/api/uvfilters/send/states',
    },
    MORTALITY: {
      SEND_FRESH: '/mobile/sweet-water/send/mortality',
      SEND_SEA: '/mobile/sea-water/send/mortality',
    },

    CONTROL_SERVICES: {
      INITIAL_DATA: '/mobile/control_service/summary',
      SAVE_DATA: '/mobile/control_service/send/chore_record',
    },
    HEALT: {
      INITIAL_DATA: '/api/necropsy/centers',
      CREATE_CASE: '/api/necropsy/necropsy_cases/case_create',
      CREATE_RECORD: '/api/necropsy/necropsy_cases/record_create',
      VALIDATE: (caseId: number) => `/api/necropsy/necropsy_cases/${caseId}`,
    },

    LOGISTIC: {
      INITIAL_DATA: '/api/logistic/fuel-supply/parameters',
      CREATE_ORDER: '/api/logistic/fuel-supply/order',
      CREATE_RECORD: (orderId: number) =>
        `/api/logistic/fuel-supply/order/${orderId}/attach-resources`,
      INITIAL_CONSUMPTION: (centerId: number) =>
        `api/logistic/fuel-supply/center/${centerId}/detail`,
      CREATE_CONSUMPTION: (centerId: number) =>
        `api/logistic/fuel-supply/center/${centerId}/consumption`,
    },
    VIEW_WEB_MONITOR: (monitorUrl?: string) => (monitorUrl ? `${monitorUrl}/login?appToken=` : ''),
  }
}
